module.exports = __webpack_public_path__ + "media/images/errors/process_not_found-5bffeafc8a25bfd143d438b39908177d.png";